import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import styles from './style.module.css';

type Props = PropsWithChildren<HTMLAttributes<HTMLHeadingElement>>;

export const PageTitle: FC<Props> = ({ children, ...props }) => {
  return (
    <h1 {...props} className={clsx(props.className, styles.root)}>
      {children}
    </h1>
  );
};
